import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from '../../data.service';

@Component({
  selector: 'app-content-page',
  templateUrl: './content-page.component.html',
  styleUrls: ['./content-page.component.scss']
})
export class ContentPageComponent implements OnInit {
  public page_name: string;
  public searchable: boolean = false;
  public keywords: string;
  public contentblocks = [];
  public loading_page = [
    {
      styles: {
        'background-image': 'url("/assets/images/expertclean/sonicare_expertclean_image3.jpg")',
        'background-color': '#FFF',
        'color': '#0073b4',
        'padding-top': '170px',
      },
      available_in: ['nl', 'fr', 'en', 'de', 'es'],
      contentLeft: {
        title: {
          nl: '<h2><strong>Laden</strong><br/><span class="thin">pagina wordt geladen<span></h2>',
          en: '<h2><strong>Loading</strong><br/><span class="thin">page is loading<span></h2>',
          fr: '<h2><strong>Loading</strong><br/><span class="thin">page is loading<span></h2>',
          de: '<h2><strong>laden</strong><br/><span class="thin">Site wird eingeladen<span></h2>',
          es: '<h2><strong>Loading</strong><br/><span class="thin">page is loading<span></h2>',
        }
      },
      contentRight: {
        title: {
          nl: 'even geduld AUB ...',
          fr: '...',
          en: 'please wait ...',
          de: 'bitte warten Sie einen moment',
          es: '...',
        },
        paragraph: {
          nl: '',
          fr: '',
          en: '',
          de: '',
          es: '',
        },
      }
    }
  ];

  // hard codes 404 in al known languages
  public not_found_page = [
    {
      styles: {
        'background-image': 'url("/assets/images/expertclean/sonicare_expertclean_image3.jpg")',
        'background-color': '#FFF',
        'color': '#0073b4',
        'padding-top': '170px',
      },
      available_in: ['nl', 'fr', 'en', 'de', 'es'],
      contentLeft: {
        title: {
          nl: '<h2><strong>404</strong><br/><span class="thin">pagina niet gevonden<br/> helaas<span></h2>',
          en: '<h2><strong>404</strong><br/><span class="thin">page not found<br/> Sorry<span></h2>',
          fr: '<h2><strong>404</strong><br/><span class="thin">pagina niet gevonden<br/> helaas<span></h2>',
          de: '<h2><strong>404</strong><br/><span class="thin">Seite leider nicht gefunden<span></h2>',
          es: '<h2><strong>404</strong><br/><span class="thin">pagina niet gevonden<br/> helaas<span></h2>',
        }
      },
      contentRight: {
        title: {
          nl: '',
          fr: '',
          en: '',
          de: '',
          es: '',
        },
        paragraph: {
          nl: '',
          fr: '',
          en: '',
          de: '',
          es: '',
        },
      }
    }
  ];

  published_statuses = ['AVAILABLE', 'SEARCHABLE'];
  constructor(public dataService: DataService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.contentblocks = this.loading_page;
    if (this.dataService.main_brand === 'AVENT') {
      this.not_found_page[0].styles = {
        'background-image': 'url("/assets/images/FACEBOOK_1200 x 630 SHARED.png")',
        'background-color': '#FFF',
        'color': '42145f',
        'padding-top': '170px',
      };
      this.loading_page[0].styles = this.not_found_page[0].styles;
    }
    this.route.params.subscribe((params) => {
      // if we have params, select the single item from all products
      let the_page: string;
      // const path = this.route.snapshot.url[0].path;
      // debugger;
      // if( path.toUpperCase() === 'FAQ'){
      //   the_page = 'FAQ';
      // }
      // if( path.toUpperCase() === 'NEWS'){
      //   the_page = 'NEWS';
      // }
      if (!!params["page"]) {
        // get the content_for this page
        the_page = params["page"];
      }
      if (!!the_page) {
        this.load_page_data(the_page);
      } else {
        // fall back to the data params passed in the router module
        this.route.data.subscribe((data) => {
          if (!!data["page"]) {
            // get the content_for this page
            this.page_name = data["page"];
            this.load_page_data(this.page_name);
          } else {
            this.contentblocks = this.not_found_page;
          }
        })
      }
    })
  }

  checkForCmForms() {
    // workaround to get cm forms to work after they are added with CMS
    setTimeout(() => {
      if (!!document.getElementById('insertCm')) {
        const script = document.createElement("script");
        script.src = 'https://js.createsend1.com/javascript/copypastesubscribeformlogic.js';
        script.async = true;
        document.body.appendChild(script);
      } else {
        console.log('got no cm form');              
      }
    }, 500)
  }

  load_page_data(page_name) {
    this.dataService.get_page_content(page_name).subscribe(page => {
      if (!!page && this.published_statuses.indexOf(page.status) > -1 && !!page.sections && page.sections.length > 0) {
        this.searchable = !!page.is_searchable;
        this.page_name = page_name;
        this.contentblocks = [];
        for (let section of page.sections) {
          let sec = section;
          try {
            sec = JSON.parse(section);
          } catch (e) {
          }
          if (this.contentblocks.length > 0) sec.allow_filter = true;
          this.contentblocks.push(sec);
        }
        this.checkForCmForms();
        // ADD news blocks to home page if defined in the env
        if (page_name === 'HOME' && !!this.dataService.news_available && this.dataService.news_count_home > 0) {
          this.dataService.get_page_content('NEWS').subscribe(news_page => {
            let news_count = 0;
            for (let news_block of news_page.sections) {
              let sec = news_block;
              try {
                let sec = JSON.parse(news_block);
              } catch (e) {
              }
              this.contentblocks.push(sec);
              news_count++;
              if (news_count >= this.dataService.news_count_home) break;
            }
          }, err2 => { });
        }
      } else {
        this.contentblocks = this.not_found_page;
      }
    }, err => {
      this.contentblocks = this.not_found_page;
    });
  }
}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/content-page/content-page.component.ts